import { call, put, select } from 'redux-saga/effects'
import { updateContractConfigData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { callApi } from '@/shared/tools/apiSagaHelper'
import { selectAuthData, selectEnergyAuthCommonData } from '@/containers/Login/AuthSelectors'
import {
  selectAddressCurrentContractActive,
  selectCharacteristicsCurrentContractActive,
  selectConfig,
  selectConsumptionCurrentContractActive,
  selectElecCurrentContractActive,
  selectPreferencesContactSubscriptionData,
  selectProviderConfigCurrentContractActive,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { buildComparatorConsumption, buildComparatorPayload } from './comparatorPayloadGeneration'

export const engineComparatorActions = {
  ENGINE_COMPARATOR_SEARCH: 'ENGINE_COMPARATOR_SEARCH',
}

export function* fetchEngineComparatorOffers({ id }) {
  const { calculateMonthlyAmountUrl } = yield select(selectEnergyAuthCommonData)
  const { country } = yield select(selectAuthData)
  const { contactId } = yield select(selectConfig)
  const { providerWorkflow } = yield select(selectProviderConfigCurrentContractActive)
  const activeAddress = (yield select(selectAddressCurrentContractActive)) ?? {}
  const { energyType, prestationType } = (yield select(selectCharacteristicsCurrentContractActive)) ?? {}
  const { clientType } = (yield select(selectPreferencesContactSubscriptionData)) ?? {}
  const consumptionData = (yield select(selectConsumptionCurrentContractActive)) ?? {}
  const activeElecData = (yield select(selectElecCurrentContractActive)) ?? {}

  yield put(
    updateContractConfigData({
      id,
      data: { comparatorLoading: true, comparatorError: null, comparatorParams: null },
    }),
  )

  try {
    const consumption = buildComparatorConsumption({ country, consumptionData })

    yield put(
      updateContractConfigData({
        id,
        data: { comparatorParams: { ...consumption, energyType } },
      }),
    )

    const payload = buildComparatorPayload({
      country,
      providerWorkflow,
      contractId: id,
      contactId,
      address: activeAddress,
      energyType,
      prestationType,
      clientType,
      consumption,
      consumptionData,
      meterOption: activeElecData.meterOption,
    })

    yield call(callApi, {
      endpoint: calculateMonthlyAmountUrl,
      showErrorSnackbar: false,
      method: 'POST',
      payload,
    })
  } catch (error) {
    yield put(
      updateContractConfigData({
        id,
        data: {
          comparatorLoading: false,
          comparatorError: error.responseData?.message || 'Engine Comparator Error',
        },
      }),
    )
  }
}
